module.exports = __webpack_public_path__ + "32575e2e59a87b97e3c3e23058a29aab.svg";